module.exports = __webpack_public_path__ + "img/secure.e49b60a4.svg";